import FormTable from './FormTable';
import FormWithSubTabs from './FormWithSubTabs';
import FormWithFormSubSectionFormTable from './FormWithFormSubSectionFormTable';
import FormTableWithMultiSubHedearTable from './FormTableWithMultiSubHeaderTable';

export {
  FormTable,
  FormWithSubTabs,
  FormWithFormSubSectionFormTable,
  FormTableWithMultiSubHedearTable
};
